<template>
  <a-modal
    v-if="visible"
    v-model="visible"
    :width="width"
    @ok="handleOk"
    :maskClosable="false"
    :closable="closable"
    :keyboard="false"
    :centered="true"
    :class="{ 'full-screen': fullScreen, 'none-footer': noneFooter }"
  >
    <template slot="title">
      <div class="dialog-title">
        <div>{{ title }}</div>
        <div class="show-warning">
          <slot name="warn"><div></div></slot>
        </div>
      </div>
    </template>
    <div class="modal-body-class">
      <slot />
    </div>
    <template slot="footer">
      <slot name="butList">
        <div style="text-align: center">
          <a-button @click="visible = false">取消</a-button>
          <a-button
            style="margin-left: 50px"
            type="primary"
            @click="() => $emit('handleOk')"
            >{{ saveText }}</a-button
          >
        </div>
      </slot>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => "Basic Modal",
    },

    closable: {
      type: Boolean,
      default: () => true,
    },

    saveText: {
      type: String,
      default: () => "保存",
    },

    width: {
      type: String,
      default: () => "50%",
    },
    fullScreen: {
      type: Boolean,
      default: () => false,
    },
    // 没有底部
    noneFooter: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      visible: false,
    };
  },

  methods: {
    openModal() {
      this.visible = true;
    },

    closeModal() {
      this.visible = false;
    },
    handleOk(e) {
      console.log(e);
      this.$emit("handleOk");
    },
  },
};
</script>
<style scoped lang="less">
::v-deep .ant-modal-body {
  overflow-y: auto;
  max-height: 70vh;
  background-color: #f5f6f8;
  padding: 0 25px;
}

::v-deep .ant-modal-header {
  background-color: #f5f6f8;
  border-radius: 20px 20px 0 0;
}
::v-deep .ant-modal-footer {
  background-color: #f5f6f8;
  border-radius: 0 0 20px 20px;
}

.dialog-title {
  // border-left: 5px solid var(--primary-color);
  // padding-left: 10px;
  display: flex;
  align-items: center;
  color: #000000;
  font-weight: 500;
  .show-warning {
    margin-left: 20px;
    font-size: 14px;
    cursor: pointer;
  }
}
.modal-body-class {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 20px;
}

::v-deep .ant-modal-content {
  background-color: transparent;
  box-shadow: none;
}

.full-screen {
  ::v-deep .ant-modal {
    top: 0;
  }
  ::v-deep .ant-modal-body {
    max-height: calc(100vh - 135px) !important;
  }
}

.none-footer {
  ::v-deep .ant-modal-footer {
    display: none;
  }
  ::v-deep .ant-modal-body {
    border-radius: 0 0 20px 20px;
  }
}
</style>
